import { SET_STORE_ONLINE } from '../action-list'

export const setStoreOnline = (storeId, online) => ({
  type: SET_STORE_ONLINE,
  storeId,
  online,
})
